import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  const regexAlphaNumeric =
  '^[a-zA-Z0-9]+$'
  const errMsgAlphaNumeric =
  'Only Alpha Numeric values are allowed'
  const regexNumeric =
  '^[0-9]+$'
  const errMsgNumeric =
  'Only Numeric values are allowed(without decimal)'
  let regexIRS= "^\\d{2}-\\d{7}[a-zA-Z0-9]{0,2}$"
  let regexSSN= "^\\d{3}-\\d{2}-\\d{4}$"
  let regexCBP= "^\\d{4}[a-zA-Z0-9]{2}-\\d{5}$"

  return Yup.object({
    billNumber: Yup.string().required(requiredMessage).nullable().max(12,"Max allowed length is 12.").matches(regexAlphaNumeric,errMsgAlphaNumeric),
    firmsCode: Yup.string().required(requiredMessage).nullable(),
    bondedCarrierType: Yup.string().required(requiredMessage).nullable(),
    bondedCarrier: Yup.string().max(12, "Max allowed length is 12.")
    .when('bondedCarrierType', {
      is: (bondedCarrierType) => (bondedCarrierType === 'IRS'),
      then:  Yup.string().required(requiredMessage).nullable().matches(regexIRS,"Incorrect Bonded Carrier ID, format: 12-1234567XX")
    })
    .when('bondedCarrierType', {
      is: (bondedCarrierType) => (bondedCarrierType === 'SSN'),
      then:  Yup.string().required(requiredMessage).nullable().matches(regexSSN,"Incorrect Bonded Carrier ID, format: 123-45-6789")
    })
    .when('bondedCarrierType', {
      is: (bondedCarrierType) => (bondedCarrierType === 'CBP'),
      then:  Yup.string().required(requiredMessage).nullable().matches(regexCBP,"Incorrect Bonded Carrier ID, format: 123456-12345")
    }).nullable(),
    containerNumber: Yup.string().nullable().max(14,"Max allowed length is 14.").matches(regexAlphaNumeric,errMsgAlphaNumeric),
    quantity: Yup.string().required(requiredMessage).nullable().max(10,"Max allowed length is 10.").matches(regexNumeric,errMsgNumeric),
    remarks: Yup.string().nullable().max(30,"Max allowed length is 30."),
  })
}

export default makeValidationSchema
